import { Tab } from "@pages/Dashboard/features/Widgets/Tab";
import { useSuplyStore } from "@pages/Dashboard/store/suplyChain.state";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import SupplyBlocks from "./SupplyChain";

import { ExecutiveSummary } from "@components/ExecutiveSummary";
import CooFlowProgressLine from "@pages/SupplyChain/components/CooFlowProgressLine";
import CustomSelect from "@components/ui-kit/CustomSelect";
import { useIsOn } from "@hooks/useFeatureToggle";
import { FEATURE_TOGGLES } from "@lib/featureToggles";
import { useState } from "react";
import { useCOOStore } from "src/store/coo.state";
import InventoryPerformance from "./InventoryPerformance";
import ManageDataEntriesModal from "./ManageDataEntriesModal";
import Scheduler from "./Scheduler";

import InventoryOverview from "./InventoryOverview";

export function SupplyChainBlock() {
  const { t } = useTranslation();
  const isRestrictedRoute = location.pathname.includes("supply-chain");
  const { customSuplyWidgets } = useSuplyStore((state) => ({
    customSuplyWidgets: state.customSuplyWidgets,
  }));
  const [modal, setModal] = useState(false);
  const { isWhatIfCOO } = useCOOStore();

  const subscriptionPerformanceEnabled = useIsOn(
    FEATURE_TOGGLES.SUBSCRIPTION_PERFORMANCE,
  );

  // COO Feature Flags
  const cooHeaderEnabled = useIsOn(FEATURE_TOGGLES.COO_HEADER);
  const cooExecutiveSummaryEnabled = useIsOn(
    FEATURE_TOGGLES.COO_EXECUTIVE_SUMMARY,
  );
  const cooInventoryPerformanceEnabled = useIsOn(
    FEATURE_TOGGLES.COO_INVENTORY_PERFORMANCE,
  );
  const cooFlowProgressLineEnabled = useIsOn(
    FEATURE_TOGGLES.COO_FLOW_PROGRESS_LINE,
  );
  const cooSupplyChainBlockEnabled = useIsOn(
    FEATURE_TOGGLES.COO_SUPPLY_CHAIN_BLOCK,
  );
  const cooSchedulerEnabled = useIsOn(FEATURE_TOGGLES.COO_SCHEDULER);
  const cooInventoryOverviewEnabled = useIsOn(
    FEATURE_TOGGLES.COO_INVENTORY_OVERVIEW,
  );
  const cooManageDataEntriesEnabled = useIsOn(
    FEATURE_TOGGLES.COO_MANAGE_DATA_ENTRIES,
  );

  const { dateRange } = useSuplyStore((state) => ({
    dateRange: state.dateRange,
  }));

  const [compareWith, setCompareWith] = useState({
    startDate: new Date(dateRange.startDate),
    endDate: new Date(dateRange.endDate),
  });

  const handleOnSaveManageDataEntries = () => {
    setModal(false);
  };

  return (
    <div>
      {cooFlowProgressLineEnabled && <CooFlowProgressLine />}

      {cooHeaderEnabled && (
        <header className="dashboard-widgets__header">
          <h1 className={styles.headerTitle}>{t("Supply chain (COO)")}</h1>
          <div className={styles.containerTab}>
            <Tab
              customSelectedWidgets={customSuplyWidgets}
              isRestrictedRoute={isRestrictedRoute}
              isConfigRoute={true}
            />
            {subscriptionPerformanceEnabled && cooManageDataEntriesEnabled && (
              <div className={styles.tabHeaderConteiner}>
                <CustomSelect
                  dateRange={dateRange}
                  compareWith={compareWith}
                  setCompareWith={setCompareWith}
                />
                <button
                  className={styles.whatIf}
                  onClick={() => setModal(true)}
                >
                  Manage Data Entries
                </button>
              </div>
            )}
          </div>
        </header>
      )}

      {isWhatIfCOO ? (
        <>
          {cooSupplyChainBlockEnabled && (
            <div className={styles.supplyBlock}>
              <h1 className={styles.titleChain}>Supply Chain</h1>
              <SupplyBlocks />
            </div>
          )}
          <div className={styles.executiveBlock}>
            {cooInventoryPerformanceEnabled && (
              <div className={styles.perfomanceBlock}>
                <InventoryPerformance />
              </div>
            )}
            {subscriptionPerformanceEnabled && cooSchedulerEnabled && (
              <div>
                <Scheduler />
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          {cooExecutiveSummaryEnabled && (
            <div className={styles.executiveBlock}>
              <ExecutiveSummary
                showWhatIf={isWhatIfCOO}
                hideSwitch={true}
                showOnly="COO"
              />
            </div>
          )}

          {cooInventoryPerformanceEnabled && (
            <div className={styles.perfomanceBlock}>
              <InventoryPerformance />
            </div>
          )}

          {cooInventoryOverviewEnabled && (
            <div className={styles.inventoryOverviewBlock}>
              <InventoryOverview />
            </div>
          )}
        </>
      )}

      {cooManageDataEntriesEnabled && (
        <ManageDataEntriesModal
          open={modal}
          onCancel={() => setModal(false)}
          onSave={handleOnSaveManageDataEntries}
        />
      )}
    </div>
  );
}
